import type { IThemeContext } from '@components/Theme'
import type { AppTheme } from '@components/Theme'
import { ThemeContext } from '@components/Theme'
import { useTheme as useMuiTheme } from '@mui/material'
import { useContext } from 'react'

function useTheme(): IThemeContext & AppTheme {
  const muiTheme = useMuiTheme<AppTheme>()
  const appTheme = useContext(ThemeContext)
  return {
    ...muiTheme,
    ...appTheme,
  }
}

export default useTheme
